import { Booking } from '@/types/booking'

const WALLET_CACHE_KEY = 'wallet_cache'

export const cacheWallet = (bookings: Booking[]) => {
  try {
    localStorage.setItem(WALLET_CACHE_KEY, JSON.stringify(bookings))
  } catch (e) {
    console.error('Failed to cache wallet:', e)
  }
}

export const getCachedWallet = (): Booking[] | null => {
  try {
    const cached = localStorage.getItem(WALLET_CACHE_KEY)
    return cached ? JSON.parse(cached) : null
  } catch (e) {
    console.error('Failed to retrieve cached wallet:', e)
    return null
  }
}
